import { render } from "./Warehouses.vue?vue&type=template&id=3c966362&scoped=true&ts=true"
import script from "./Warehouses.vue?vue&type=script&lang=ts"
export * from "./Warehouses.vue?vue&type=script&lang=ts"

import "./Warehouses.vue?vue&type=style&index=0&id=3c966362&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c966362"]])

export default __exports__